import { generateKey } from './generateKey';

export const encrypt = async (
  salt: string,
  iv: string,
  passPhrase: string,
  plainText: string,
  keySize: number,
  iterationCount: number,
) => {
  const CryptoJS = (await import('crypto-js')).default;
  const key = await generateKey(salt, passPhrase, keySize, iterationCount);
  const encrypted = CryptoJS.AES.encrypt(plainText, key, {
    iv: CryptoJS.enc.Hex.parse(iv),
  });
  return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
};
